const dataLayer = () => (typeof window !== 'undefined' ? window?.dataLayer : []);

export const pushToDataLayer = (trackingData: Record<string, any>) => {
  dataLayer()?.push(trackingData);
};
